<template>
  <div class="tour-gallery-img-wrapper">
    <img width="900" height="600"
      class="tour-gallery-img lazyload"
      draggable="false"
      :alt="image.title" 
      :data-src="getContentfulImgURL({
        url: image.url,
        width: 900,
        height: 600,
        quality: 90,
        fit: 'pad',
        bgColor: 'rgb:000000'
      })">
    <div class="tour-gallery-img-caption">
      <span>
        {{ image.title }}
      </span>
    </div>
  </div>
</template>
<script>
import imageOptimo from "~/mixins/imageOptimoMixin.js";

export default {
  name: "TourGalleryImg",
  mixins: [imageOptimo],
  props: {
    image: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.tour-gallery-img-wrapper {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  padding-bottom: 66.67%;
  background-color: black;
  height: 0;
  img {
    position: absolute;
    top: 0;
    object-position: center center;
    height: 100%;
    object-fit: cover;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  .tour-gallery-img-caption {
    position: absolute;
    width: 100%;
    bottom: 0;
    // padding: 16px;
    background-color: rgba(0, 0, 0, 0.75);
    color: white;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    height: 64px;

    span {
      color: white;
    }
  }
}
</style>
